
<div :class="jel_getClassObject(content)">
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <ValidationProvider
    v-slot="validationContext"
    :name="content.libTelephone"
    :rules="`required|is_telephone_valid|compteValidation:telephone`"
    tag="div"
  >
    <b-form-group :label="content.libTelephone" label-for="telephone">
      <!-- :value au lieu de v-model: éviter le keydown automatique de v-model -->
      <b-form-input
        :id="content.idHTML ? content.idHTML : 'telephone'"
        v-model="telephone"
        type="tel"
        :maxlength="$t('compte.telephone.mask').length"
        :state="getValidationState(validationContext)"
        @keydown.enter="getValidationState(validationContext)"
        @keyup.native="maskTelephone($event)"
      ></b-form-input>
      <ErreurValidation
        id="telephone-live-feedback"
        :message="validationContext.errors[0]"
      ></ErreurValidation>
    </b-form-group>
    <Hyperlien
      v-if="content.libExplication"
      class="mb-2 mt-n3"
      :content="getContentAide"
    ></Hyperlien>
  </ValidationProvider>
</div>
